<template>
  <v-container fluid>
    <v-layout column class="tarifs-container">
      <h1 class="text-uppercase text-xs-center">Nos tarifs</h1>
      <span class="text-xs-center font-weight-medium secondary--text">
        Une facturation rationalisée pour une expertise certifiée par un Expert en Droit Social<br v-if="!$vuetify.breakpoint.smAndDown" />au service du Chef d’entreprise exclusivement.
      </span>
      <p>Les prestations sont facturées <b>au temps passé</b> selon un taux horaire. Les honoraires varient en fonction de la difficulté du dossier et font l’objet d’un <b>devis préalable systématique.</b></p>
      <p>La facturation peut s’effectuer sur <b>une base mensuelle sous réserve de la signature d’une lettre de mission de conseil annuel</b>, dans laquelle sont détaillées les prestations comprises dans la mission.</p>
      <p>Nous demeurons à votre disposition et celle de votre entreprise pour toute demande de renseignement et pour toute autre prestation “sur-mesure”.</p>
      <p>Toutes les prestations ne peuvent être listées : si vous ne voyez pas le service que vous attendez, cela ne veut pas dire que nous ne le proposons pas. C’est simplement que la demande est moins fréquente ou encore impossible à chiffrer de manière forfaitaire. </p>
      <p class="mb-4"><b><a href="/Tarifs-MC-Consultant.pdf" target="_blank">Cliquez ici</a>&nbsp; pour télécharger notre grille tarifaire.</b></p>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'tarifs',
  created () {
    window.scrollTo(0, 0)
  }
}
</script>

<style lang="stylus">
.tarifs-container
  margin: 36px 0
  padding: 0 80px

.tarifs-container h1
  font-size: 2.4rem

.tarifs-container p,
.tarifs-container span
  font-size: 16px
  padding: 0 120px

.tarifs-container span
  margin: 24px 0

.tarifs-container p
  margin: 16px 0

.mdOnly .tarifs-container,
.smOnly .tarifs-container,
.xsOnly .tarifs-container
  padding: 0 !important

/* Style for medium devices */
.mdOnly .tarifs-container
  margin: 32px 0

.mdOnly .tarifs-container span
  margin: 24px 0

.mdOnly .tarifs-container p
  margin: 16px 0

/* Style for small devices */
.smOnly .tarifs-container
  margin: 32px 0

.smOnly .tarifs-container p,
.smOnly .tarifs-container span
  padding: 0 60px

.smOnly .tarifs-container span
  margin: 24px 0

.smOnly .tarifs-container p
  margin: 12px 0

/* Style for extra small devices */
.xsOnly .tarifs-container
  margin: 16px 0

.xsOnly .tarifs-container h1
  font-size: 1.8rem

.xsOnly .tarifs-container p,
.xsOnly .tarifs-container span
  font-size: 14px
  padding: 0 24px

.xsOnly .tarifs-container span
  margin: 24px 0

.xsOnly .tarifs-container p
  margin: 10px 0
</style>

